import React from "react";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import MedicationIcon from "@mui/icons-material/Medication";
import { Box } from "@mui/material";
import CustomCard from "../../../../shared/CustomCard";
function Manager() {
  const cardsData = [
    {
      title: "Assign Approvals",
      icon: AssignmentTurnedInIcon,
      path: "/approvals/assign",
    },
    {
      title: "Approval Limit",
      icon: AccountBalanceIcon,
      path: "/approvals/limit",
    },
    {
      title: "ICD Coverage",
      icon: MedicalServicesIcon,
      path: "/approvals/coverage",
    },
    {
      title: "Medication Approvals",
      icon: MedicationIcon,
      path: "/approvals/medication",
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box className=" grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {cardsData.map((report, index) => (
          <CustomCard
            key={index}
            title={report.title}
            icon={report.icon}
            path={report.path}
            color="#0070C2"
          />
        ))}
      </Box>
    </Box>
  );
}

export default Manager;
